import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import Navbar from 'components/UI/Navbar/Navbar';
import CouponForm from './CouponForm';
import { couponApi } from '../../service/CouponService';

export interface CouponFormData {
  code: string;
  promoType: 'FIXED' | 'PERCENT' | 'ZERO_FEE';
  appliedOn: 'B2B' | 'B2C' | 'ALL' | 'HIDDEN' | 'APP';
  channel: 'IOS' | 'ANDROID' | 'APP' | 'WEB' | 'ALL';
  amount: string;
  bookingFrom: string;
  bookingUntil: string;
  maxUsage: string;
  maxUsagePerUser: string;
}

export default function CouponFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const mode: 'create' | 'edit' = id ? 'edit' : 'create';

  const fetchCoupon = async (couponId: string) => {
    const list = await couponApi.getAll();
    return list.find((c: any) => c.id === Number(couponId));
  };

  const handleSubmit = async (form: CouponFormData) => {
    const payload = {
      id: id ? Number(id) : undefined,
      type: form.promoType,
      appliedOn: form.appliedOn,
      channel: form.channel,
      amount: form.promoType === 'ZERO_FEE' ? 0 : Number(form.amount),
      maxDiscount: null,
      minOrderTotal: null,
      startsAt: new Date(form.bookingFrom).toISOString(),
      endsAt: new Date(form.bookingUntil).toISOString(),
      totalLimit: form.maxUsage ? Number(form.maxUsage) : null,
      perUserLimit: form.maxUsagePerUser ? Number(form.maxUsagePerUser) : null,
    };

    if (mode === 'edit') {
      await couponApi.update(payload);
    } else {
      payload['code'] = form.code;
      await couponApi.create(payload);
    }

    navigate('/host/coupons');
  };

  return (
    <>
      <Navbar />
      <Box sx={{ bgcolor: '#f7f8fa', minHeight: 'calc(100vh - 64px)', py: 4 }}>
        <Box sx={{ maxWidth: 880, mx: 'auto', px: { xs: 2, md: 3 } }}>
          <Typography variant="h4" fontWeight={700} mb={1}>
            {mode === 'edit' ? 'Edit Coupon' : 'Create Coupon'}
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={4}>
            Configure the discount, when it applies, and where customers can redeem it.
          </Typography>

          <CouponForm
            mode={mode}
            id={id ?? undefined}
            fetchCoupon={fetchCoupon}
            onSubmit={handleSubmit}
          />
        </Box>
      </Box>
    </>
  );
}
